// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "bs-platform/lib/es6/curry.js";
import * as React from "react";
import * as Caml_option from "bs-platform/lib/es6/caml_option.js";
import * as MaterialUI_Grid from "@divertise-asia/bs-mui/lib/es6/src/Components/MaterialUI_Grid.bs.js";
import * as ModalDialog$CTEM from "./ModalDialog.bs.js";
import * as MaterialUI_Button from "@divertise-asia/bs-mui/lib/es6/src/Components/MaterialUI_Button.bs.js";
import * as MaterialUIDataType from "@divertise-asia/bs-mui/lib/es6/src/MaterialUIDataType.bs.js";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";

function ModalRemove(Props) {
  var onHandleClose = Props.onHandleClose;
  var onConfirm = Props.onConfirm;
  return React.createElement(ModalDialog$CTEM.make, {
              className: "modal-custom text-center",
              onHandleClose: onHandleClose,
              children: React.createElement(Grid, Curry.app(MaterialUI_Grid.Container.makeProps(undefined, undefined)(Caml_option.some(MaterialUIDataType.FlexDirection.row), 3, undefined), [
                        undefined,
                        undefined,
                        Caml_option.some(MaterialUIDataType.AlignItems.center),
                        undefined,
                        undefined,
                        undefined,
                        undefined,
                        undefined,
                        undefined,
                        undefined,
                        Caml_option.some(null),
                        undefined,
                        undefined
                      ]), React.createElement(Grid, Curry.app(MaterialUI_Grid.Item.makeProps(undefined, undefined)(undefined, undefined, undefined), [
                            undefined,
                            Caml_option.some(MaterialUIDataType.GridSize.size(12)),
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            Caml_option.some(React.createElement("p", undefined, "Delete this model?")),
                            undefined,
                            undefined
                          ])), React.createElement(Grid, Curry.app(MaterialUI_Grid.Item.makeProps(undefined, undefined)(undefined, undefined, undefined), [
                            undefined,
                            Caml_option.some(MaterialUIDataType.GridSize.size(6)),
                            undefined,
                            undefined,
                            undefined,
                            "text-right",
                            Caml_option.some(React.createElement(Button, {
                                      children: "Delete",
                                      className: "btn-solid-color1",
                                      variant: MaterialUI_Button.Variant.contained,
                                      onClick: onConfirm
                                    })),
                            undefined,
                            undefined
                          ])), React.createElement(Grid, Curry.app(MaterialUI_Grid.Item.makeProps(undefined, undefined)(undefined, undefined, undefined), [
                            undefined,
                            Caml_option.some(MaterialUIDataType.GridSize.size(6)),
                            undefined,
                            undefined,
                            undefined,
                            "text-left",
                            Caml_option.some(React.createElement(Button, {
                                      children: "Don't Delete",
                                      className: "btn-solid-color2",
                                      variant: MaterialUI_Button.Variant.contained,
                                      onClick: (function (param) {
                                          return Curry._1(onHandleClose, undefined);
                                        })
                                    })),
                            undefined,
                            undefined
                          ])))
            });
}

var make = ModalRemove;

export {
  make ,
  
}
/* react Not a pure module */
